export const vendorRegistrationMutation = (builder) => ({
    vendorRegistration: builder.mutation({
        query: (payload) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/vendor_onboarding',
                method: 'POST',
                body: payload,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
            };
        },
    }),
});
